import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { ProblemInformationDto } from 'src/app/data-transfer/entities/evaluation-entities/problem-information-dto';
import { MatTree, MatTreeNestedDataSource } from '@angular/material/tree';
import { Subscription } from 'rxjs';
import { ColorThemeService, COLOR_THEME_DARK, COLOR_THEME_NAME } from 'src/app/navigation/services/color-theme-service';
import { NestedTreeControl } from '@angular/cdk/tree';

@Component({
  selector: 'app-analysis-not-possible-dialog',
  templateUrl: './analysis-not-possible-dialog.component.html',
  styleUrls: ['./analysis-not-possible-dialog.component.scss']
})
export class AnalysisNotPossibleDialogComponent implements OnInit, OnDestroy {
  @ViewChild('nestedTree') nestedTree!: MatTree<any>;

  generalExplanation!: string;

  errorMessageList: string[] = [];

  private problemInformation: ProblemInformationDto[];

  nestedTreeControl = new NestedTreeControl<ProblemInformationDto>((node: ProblemInformationDto) => node.reasons);
  treeDataSource: MatTreeNestedDataSource<ProblemInformationDto>;
  isDarkTheme = false;

  private themeSubscription?: Subscription;

  constructor(
    public dialogRef: MatDialogRef<AnalysisNotPossibleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: { generalExplanation: string, problemInformation: ProblemInformationDto[] },
    private translateService: TranslocoService,
    private colorThemeService: ColorThemeService
  ) {
    this.problemInformation = data.problemInformation;
    this.generalExplanation = data.generalExplanation;

    this.getProblemReasonsRecursively(this.problemInformation);

    this.treeDataSource = new MatTreeNestedDataSource<ProblemInformationDto>();
    this.themeSubscription = this.colorThemeService.colorThemeSubject.subscribe((nextValue) => {
      this.isDarkTheme = nextValue === COLOR_THEME_DARK;
    });
  }

  ngOnInit(): void {
    this.treeDataSource.data = this.problemInformation;
    this.nestedTreeControl.dataNodes = this.problemInformation;
    this.nestedTreeControl.collapseAll();
    this.isDarkTheme = localStorage.getItem(COLOR_THEME_NAME) === COLOR_THEME_DARK;
  }

  getTreeLabel(problemInformation: ProblemInformationDto){
    let label = "";

    if (problemInformation.reasons && problemInformation.reasons.length > 0) {
      label += problemInformation.fieldName;
    } else {
      label += problemInformation.errorMessage;
    }

    if (problemInformation.name && problemInformation.name.trim() != "") {
      label += ": " + problemInformation.name;
    }

    if (problemInformation.index != null){
      label += " (" + this.translateService.translate('analysisNotPossibleInfo.position') + ": " + (problemInformation.index + 1) + ")";
    }

    return label;
  }

  getProblemReasonsRecursively(problemInformationList: ProblemInformationDto[], errorMessage: string = '') {
    for (const problemInformation of problemInformationList) {
      const newErrorMessage = errorMessage.concat(problemInformation.fieldName);

      if (problemInformation.reasons.length != 0) {
        this.getProblemReasonsRecursively(problemInformation.reasons, newErrorMessage);
      } else {
        this.errorMessageList.push(newErrorMessage);
      }
    }
  }

  hasChild(node: ProblemInformationDto): boolean {
    return node.reasons && node.reasons.length > 0;
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
  }
}
